import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { FHEContainer, FHEButton } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { TableHomeProducts } from '../tables';
import { getProductsByHomeId, deleteProduct } from '../../../data/Products/actions';
import getSelectors from '../selectors';

class HomeProducts extends Component {
    static propTypes = {
        getProductsByHomeId: PropTypes.func.isRequired,
        deleteProduct: PropTypes.func.isRequired,
        isActive: PropTypes.bool,
        productsInitialized: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        homeId: PropTypes.string.isRequired,
        homeBoxMac: PropTypes.string.isRequired
    };

    static defaultProps = {
        isActive: true
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            initialized: false,
            error: null,
            tableKey: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, initialized, tableKey } = state;
        const { isActive, productsInitialized } = props;
        if (!productsInitialized && isActive && !needGetData && !loading && !error && !fetching && !initialized)
            return { needGetData: true, loading: true };
        if (isActive && !tableKey) return { tableKey: true };

        return null;
    }
    componentDidMount() {
        const { needGetData } = this.state;
        if (needGetData) this.getProducts();
    }

    componentDidUpdate() {
        const { isActive, productsInitialized } = this.props;
        const { needGetData, fetching, error } = this.state;

        if (!productsInitialized && isActive && needGetData && !fetching && !error) {
            this.getProducts();
        }
    }

    getProducts = () => {
        const { getProductsByHomeId, homeId } = this.props;
        this.state.fetching = true;
        getProductsByHomeId(homeId)
            .then(() => {
                this.setState({
                    error: null,
                    loading: false,
                    fetching: false,
                    needGetData: false,
                    initialized: true
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false });
            });
    };

    deletingProduct = (productType, identifier, type, callbackRowActionLoading) => {
        const { deleteProduct, homeId } = this.props;
        deleteProduct(homeId, productType, identifier, type)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.deleteProductSuccess`));
            })
            .catch(err => {
                const message = Translator.translateWithFallback(
                    `api.message.${err.message ? err.message : err}`,
                    'generic.products.actions.deleteProductError'
                );
                Toastr.error(message);
            })
            .finally(() => {
                callbackRowActionLoading(false);
            });
    };

    deleteProduct = (rowData, callbackRowActionLoading) => {
        callbackRowActionLoading(true);
        Toastr.confirm(
            Translator.translate('generic.products.actions.confirmationDeleteProduct', rowData.label),
            Translator.translate('generic.products.actions.confirmationDeleteProductTitle'),
            {
                onYes: () => {
                    this.deletingProduct(rowData.productType, rowData.productIdentifier, rowData.type, callbackRowActionLoading);
                },
                onNo: () => {
                    callbackRowActionLoading(false);
                }
            }
        );
    };

    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };
    addProduct = () => {
        const { history, homeBoxMac } = this.props;
        return history.push({ pathname: `/${history.environment}/products/add`, state: { boxMac: homeBoxMac } });
    };

    renderChildren = () => {
        const { tableKey } = this.state;
        const { profile, homeBoxMac, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        return (
            <Fragment>
                {(profile.get('admin') || userRights.includes('addProduct')) && (
                    <Grid container justify="center" alignItems="center">
                        <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center" direction="column">
                            <FHEButton
                                disabled={!homeBoxMac}
                                tooltip={
                                    !homeBoxMac
                                        ? Translator.translate(
                                              `generic.products.addProduct.tooltip`,
                                              Translator.translate(`${history.environment}.centerName`)
                                          )
                                        : null
                                }
                                content={Translator.translate(`generic.products.addProduct.action`)}
                                clickFunction={this.addProduct}
                            />
                        </Grid>
                    </Grid>
                )}
                <TableHomeProducts key={tableKey} deleteProduct={this.deleteProduct} />
            </Fragment>
        );
    };

    render() {
        const { error, loading } = this.state;
        const { productsInitialized } = this.props;

        return (
            <FHEContainer
                hasNoClassContainer
                loading={loading && !productsInitialized}
                error={error}
                onClickFunc={this.retryGetData}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state),
        homeId: homeId,
        productsInitialized: selectors.getHomeByHomeId(state, homeId).getIn(['productsInitialized'], false),
        homeBoxMac: selectors.getBoxByHomeId(state, homeId).getIn(['macAddress'], '')
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/HomeProducts',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getProductsByHomeId, deleteProduct }), dispatch)
        )(HomeProducts)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/HomeProducts.js